(function () {
  const currentLocale = document.documentElement.lang || 'en';
  const storageKey = 'th_default_settings_content';

  const translationKeys = [
    'button_text_before',
    'button_text_after',
    'wishlist_button_text_before',
    'wishlist_button_text_after',
    'notification_banner_header_text',
    'notification_banner_button_text',
    'wishlist_page_title',
    'share_title',
    'share_description',
    'add_to_cart',
    'load_more_button_text',
    'Wishlist_page_login_or_register',
    'remove_product',
    'product_collection_button_text_before',
    'product_collection_button_text_after',
    'sold_out',
    'no_product',
    'product_add_to_wishlist',
    'product_remove_wishlist',
    'product_add_to_cart',
    'product_add_to_cart_error_title',
    'product_add_to_cart_error_message',
    'view_list_button',
    'view_cart_button',
    'wishlist_dropdown_text',
    'wishlist_model_title',
    'wishlist_model_label',
    'wishlist_model_placeholder',
    'default_wishlist_title',
    'wishlist_model_description',
    'wishlist_model_create_button',
    'wishlist_model_cancel_button',
    'wishlist_page_description',
    'wishlist_page_login_text',
    'wishlist_page_Register_text',
    'all_product_add_to_cart_button_text',
    'clear_cart_message'
  ];

  const translationMap = {
    'button_text_before': 'add_to_wishlist',
    'button_text_after': 'added_to_wishlist',
    'wishlist_button_text_before': 'add_to_wishlist',
    'wishlist_button_text_after': 'added_to_cart',
    'notification_banner_header_text': 'notification_header',
    'notification_banner_button_text': 'view_wishlist',
    'wishlist_page_title': 'wishlist_title',
    'share_title': 'share_title',
    'share_description': 'share_description',
    'add_to_cart': 'add_to_cart',
    'load_more_button_text': 'load_more',
    'Wishlist_page_login_or_register': 'login_or_register',
    'remove_product': 'remove_product',
    'product_collection_button_text_before': 'add_to_wishlist',
    'product_collection_button_text_after': 'added_to_wishlist',
    'sold_out': 'sold_out',
    'no_product': 'no_product',
    'product_add_to_wishlist': 'product_added',
    'product_remove_wishlist': 'product_removed',
    'product_add_to_cart': 'product_added_to_cart',
    'product_add_to_cart_error_title': 'error_title',
    'product_add_to_cart_error_message': 'error_message',
    'view_list_button': 'view_wishlist',
    'view_cart_button': 'view_cart',
    'wishlist_dropdown_text': 'create_wishlist',
    'wishlist_model_title': 'model_title',
    'wishlist_model_label': 'model_label',
    'wishlist_model_placeholder': 'model_placeholder',
    'default_wishlist_title': 'default_title',
    'wishlist_model_description': 'model_description',
    'wishlist_model_create_button': 'create_button',
    'wishlist_model_cancel_button': 'cancel_button',
    'wishlist_page_description': 'description',
    'wishlist_page_login_text': 'login_text',
    'wishlist_page_Register_text': 'register_text',
    'all_product_add_to_cart_button_text': 'add_all_to_cart',
    'clear_cart_message': 'clear_cart_message'
  };

  function getTranslation(key) {
    const translationKey = translationMap[key];

    if (!window.wishlistTranslations && document.getElementById('wishlist-translations')) {
      try {
        window.wishlistTranslations = JSON.parse(
          document.getElementById('wishlist-translations').textContent
        );
      } catch (e) {
        console.error('[Wishlist Translator] Error parsing translations:', e);
      }
    }

    if (window.wishlistTranslations && window.wishlistTranslations[translationKey]) {
      return window.wishlistTranslations[translationKey];
    }

    return null;
  }

  function translateWishlistData() {
    try {
      const wishlistData = localStorage.getItem(storageKey);
      if (!wishlistData) {
        return;
      }

      const data = JSON.parse(wishlistData);
      if (!data || !data.data || !data.data.setting) {
        console.warn('[Wishlist Translator] Invalid wishlist data structure:', data);
        return;
      }

      let isModified = false;
      const appliedTranslations = {};

      translationKeys.forEach(key => {
        const translation = getTranslation(key);
        if (data.data.setting[key] && translation) {
          appliedTranslations[key] = {
            original: data.data.setting[key],
            translated: translation
          };
          data.data.setting[key] = translation;
          isModified = true;
        }
      });

      if (isModified) {
        localStorage.setItem(storageKey, JSON.stringify(data));
      }
    } catch (error) {
      console.error('[Wishlist Translator] Error translating wishlist data:', error);
    }
  }

  function setupStorageListener() {
    window.addEventListener('storage', (event) => {
      if (event.key === storageKey) {
        translateWishlistData();
      }
    });
  }

  function init() {
    translateWishlistData();
    setupStorageListener();

    document.addEventListener('DOMContentLoaded', () => {
      translateWishlistData();
    });

    window.addEventListener('load', () => {
      translateWishlistData();
    });
  }

  init();
})(); 